<template>
  <div :class="hiddenClass">
    <header id="header_hea">
      <div v-if="showDownload" class="dowloadApp flex-row justify-between align-center">
        <div class="flex-row align-center">
          <van-icon class="icon" name="cross" @click="handleClose" />
          <img src="../assets/images/logo/logo.png" alt="">
        </div>
        <a :href="$store.state.home.app_download_link" class="btn pr-10">Baixar App</a>
      </div>
      <div class="headerBox flex-row justify-between">
        <div>
          <div class="menu_btn" @click="showLeftNavClick">
            <!-- <van-icon
              v-show="!$parent.show_left_nav"
              name="ascending"
              class="menu_icon"
            />
            <van-icon
              v-show="$parent.show_left_nav"
              name="descending"
              class="menu_icon"
            /> -->
            <!-- <svg
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              :class="[$parent.show_left_nav ? 'left-tar svg_icon' : 'svg_icon']"
              width="25"
              height="20"
            >
              <path
                d="M1.62517 14.0283C1.36457 14.0283 1.11456 13.9247 0.930296 13.7405C0.746027 13.5562 0.642431 13.3063 0.642431 13.0457C0.642431 12.7851 0.746027 12.5351 0.930296 12.3509C1.11456 12.1666 1.36457 12.0631 1.62517 12.0631H8.17569C8.43629 12.0631 8.68589 12.1666 8.87016 12.3509C9.05443 12.5351 9.15803 12.7851 9.15803 13.0457C9.15803 13.3063 9.05443 13.5562 8.87016 13.7405C8.68589 13.9247 8.43629 14.0283 8.17569 14.0283H1.62517ZM11.7144 13.6008C11.6228 13.5095 11.5501 13.4011 11.5005 13.2816C11.4509 13.1622 11.4254 13.0342 11.4254 12.9048C11.4254 12.7755 11.4509 12.6475 11.5005 12.528C11.5501 12.4086 11.6228 12.3001 11.7144 12.2088L14.0014 9.92107H1.62517C1.36457 9.92107 1.11456 9.81755 0.930296 9.63328C0.746027 9.44901 0.642431 9.19909 0.642431 8.9385C0.642431 8.6779 0.746027 8.42798 0.930296 8.24371C1.11456 8.05944 1.36457 7.95592 1.62517 7.95592H14.0014L11.7144 5.66814C11.5298 5.48356 11.4262 5.23321 11.4262 4.97216C11.4262 4.71111 11.5298 4.46075 11.7144 4.27616C11.899 4.09157 12.1495 3.98787 12.4105 3.98787C12.6715 3.98787 12.922 4.09157 13.1066 4.27616L17.0703 8.24005C17.1619 8.33133 17.2346 8.4398 17.2842 8.55924C17.3338 8.67867 17.3594 8.80671 17.3594 8.93603C17.3594 9.06536 17.3338 9.19341 17.2842 9.31284C17.2346 9.43228 17.1619 9.54075 17.0703 9.63203L13.1066 13.5959C13.0153 13.6875 12.9066 13.7602 12.7871 13.8098C12.6677 13.8594 12.5398 13.8849 12.4105 13.8849C12.2812 13.8849 12.1529 13.8594 12.0335 13.8098C11.914 13.7602 11.8057 13.6875 11.7144 13.5959V13.6008ZM1.62517 5.82208C1.36457 5.82208 1.11456 5.71856 0.930296 5.5343C0.746027 5.35003 0.642431 5.10011 0.642431 4.83951C0.642431 4.57891 0.746027 4.32899 0.930296 4.14472C1.11456 3.96045 1.36457 3.85693 1.62517 3.85693H8.17569C8.43629 3.85693 8.68589 3.96045 8.87016 4.14472C9.05443 4.32899 9.15803 4.57891 9.15803 4.83951C9.15803 5.10011 9.05443 5.35003 8.87016 5.5343C8.68589 5.71856 8.43629 5.82208 8.17569 5.82208H1.62517Z"
                fill=""
              />
            </svg> -->
            <div :class="[$parent.show_left_nav ? 'left-tar topLeftMenu' : 'topLeftMenu']" />
          </div>
          <div class="top_title">
            <img src="../assets/images/logo/logo.png" class="logo" @click="$router.push('/')">
          </div>
        </div>
        <div>
          <div v-show="!$parent.token" class="login-register">
            <div class="login-btn" @click="$parent.login()">
              {{ $t("登录") }}
            </div>
            <div class="register-btn" @click="$parent.register()">
              {{ $t("注册") }}
            </div>
          </div>
          <div v-show="$parent.token" class="user-balance">
            <div class="bnumber">
              <div class="top_balance">
                <img class="jinbi" src="../assets/images/common/a04.png">
                <div class="balance">
                  {{ data.money }}
                </div>

                <img class="refresh_btn" src="../assets/images/person/a03.png" :class="[moneyLoading ? 'loading' : '']"
                  @click="getUserInfoPerson()">
              </div>
              <div class="kefu_box" @click="showSup">
                <img src="../assets/images/common/kefu.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import Fetch from "../utils/fetch";
import { EventBus } from "../utils/utils";
export default {
  name: "Header",
  props: {
    showDownload: Boolean
  },
  data() {
    return {
      shouldHide: true,
      data: {},
      show_left_nav: false,
      show_popover: false,
      showDeposit: false,
      actions: [
        { text: this.$t('提现'), icon: "idcard" },
      ],
      currentDate: new Date(),
      interval: null,
      moneyLoading: false
    };
  },
  computed: {
    hiddenClass() {
      return {
        //true是隐藏 false是不隐藏
        "hidden-xs-only": this.shouldHide,
      };
    },
    showLeftNav() {
      return {
        "left-tar": this.show_left_nav,
      };
    },
    formattedTime() {
      return this.formatDate(this.currentDate);
    },
  },
  created() {
    this.$bus.$on("send2headshow", (bool) => {
      this.shouldHide = bool;
    });
    this.startTimer();
    this.getUserInfoPerson();
  },
  mounted() {
    var that = this;
    document.addEventListener("click", function (e) {
      if (e.target.className != "el-icon-caret-bottom fz3") {
        that.showDeposit = false;
      }
    });
    console.log(this.showDownload, '=this.$store.home')
    EventBus.$on('refresh_bet', this.getUserInfoPerson)
  },
  beforeDestroy() {
    this.stopTimer();
    EventBus.$off('refresh_bet', this.getUserInfoPerson)
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
    showRecharge() {
      this.$parent.isShowRecharge = true;
    },
    showSup() {
      this.$parent.isShowSupport = true;
      EventBus.$emit('supTabChange', 0);
    },
    show(e) {
      this.showDeposit = !this.showDeposit;
    },
    doCopy(val) {
      let _this = this;
      this.$copyText(String(val)).then(
        function (e) {
          _this.$toast({
            background: "#07c160",
            message: _this.$t("复制成功"),
          });
        },
        function (e) {
        }
      );
    },
    getUserInfoPerson() {
      this.moneyLoading = true
      Fetch("/user/userinfo").then((r) => {
        console.log(r);
        this.data = r.data.userinfo;
        if (!this.data.money) {
          this.data.money = '0.00';
        }
        this.moneyLoading = false
      });
    },
    startTimer() {
      this.interval = setInterval(() => {
        this.currentDate = new Date();
      }, 1000);
    },
    stopTimer() {
      clearInterval(this.interval);
    },
    formatDate(date) {
      let brazilianDate = new Date(
        date.getTime() + date.getTimezoneOffset() * 60000 - 180 * 60000
      );
      return (
        brazilianDate.toLocaleDateString("pt-BR", {
          month: "2-digit",
          day: "2-digit",
        }) +
        " " +
        brazilianDate.toLocaleTimeString("pt-BR", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
      );
    },
    showLeftNavClick() {
      this.$parent.nowScrollTop = document.getElementsByTagName('html')[0].scrollTop || document.body.scrollTop
      console.log(this.$parent.nowScrollTop, 'this.$parent.nowScrollTop')
      setTimeout(() => {
        this.$parent.show_left_nav = !this.$parent.show_left_nav;
      }, 100);
    },
    fundosAction(act) {
      if (act.text === "Depósito") {
        this.$router.push("recharge");
      }
      if (act.text === "Saque") {
        this.$router.push("withdraw");
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/variables.less";
@headerHeight: 1.2rem;

/deep/ .el-icon-caret-bottom {
  color: @textcolor6;
}

.flex-row {
  display: flex;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.align-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-center {
  justify-content: center;
}

.pr-10 {
  padding-right: 10px;
}

.headerBox {
  padding: 10px 6px 10px 4px;
  border-bottom: 1px solid @bodercolor2;
}

.header-deposit-list {
  position: absolute;
  right: 0;
  left: 0;
  top: 110%;
  opacity: 1;
  height: auto;
  border: 0.02rem solid @bodercolor2;
  padding: 0.15rem 0;
  transition: top 0.1s, height 0.1s;
  border-radius: 0.1rem;
  text-align: center;
  overflow: hidden;
  background-color: @secondary-color;

  article {
    padding: 0 0.19rem;
    line-height: 0.8rem;
    display: flex;
    align-items: center;
    font-size: 0.3rem;
    color: #fff;
    margin: 0;
    min-width: 1.7rem;
    text-align: left;
  }
}

header {
  position: fixed;
  box-sizing: border-box;
  width: 100%;
  max-width: @maxWidth;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  // padding: 0 2px;
  // height: @headerHeight;
  background-color: @primary-color;
  //background-image: url("../assets/images/common/top_bg.jpg");
  // padding-right: 10px;
  z-index: 6;
}

.menu_btn {
  float: left;
  width: 0.66rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu_icon {
  font-size: 0.6rem !important;
  color: @textcolor1;
}

#pc_time {
  color: @textcolor1;
  display: flex;
  width: 5rem;
  flex-direction: column;
  font-size: 0.32rem;
  align-items: center;
  justify-content: center;
  justify-items: center;
  height: 100%;
  font-weight: 700;

  span {
    display: block;
    height: 50%;
    display: flex;
    align-items: center;
  }
}

.top_title {
  //text-align: center;
  // font-size: 24px;
  display: flex;
  height: 100%;
  float: left;
  align-items: center;
  justify-items: center;
  //margin-left: 0.1rem;
}

.leftPng {
  width: 0.5rem;
}

.left-tar {
  transform: rotateY(180deg);
}

.logo {
  width: 3.5rem;
}

.login-register {
  // position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.login-btn {
  padding: 6px 15px;
  color: @primary-color;
  display: flex;
  align-items: center;
  border-radius: 0.15rem;
  background-color: @textcolor1;
  font-size: 11px;
  margin-right: 6px;
  border: 1px solid @textcolor1;
}

.register-btn {
  padding: 6px 15px;
  color: @textcolor1;
  //background-color: @mainColor;
  border: 1px solid @textcolor1;
  display: flex;
  align-items: center;
  border-radius: 0.15rem;
  font-size: 11px;
}

.fund_btn {
  padding: 0.25rem 0.25rem;
  color: @primary-color;
  // border: 1px solid @anttextcolor;
  display: flex;
  align-items: center;
  border-radius: 0.15rem;
  margin-right: 0.2rem;
  font-size: 0.26rem;
  margin-left: 0.21rem;
  background: @ButtonColor;
  position: relative;

  span {
    color: @textcolor6;

    em {
      color: fade(@textcolor6, 80);
    }
  }
}

.simg {
  font-size: 0.5rem;
  margin-right: 0.1rem;
  color: @popupTextColor;
}

.svg_icon path {
  fill: @popupTextColor;
}

.top_balance {
  // height: 1rem;
  margin-top: 1px;
  // padding: 0.1rem 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid @bodercolor2;
  border-radius: 30px;
}

.refresh_btn {
  width: 0.4rem;
  height: 0.4rem;
  margin-left: 0.1rem;
}

.jinbi {
  height: 18px;
  margin-right: 4px;
}

.user_info {
  color: @textcolor1;
  padding-right: 0.4rem;
  width: 3.2rem;
  font-size: 0.34rem;
}

#hd_avt {
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 50%;
}

.bnumber {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.balance {
  color: #ecc15c;
  font-size: 11px;
  font-weight: 500;
  text-decoration: underline;
}

.user-balance {
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  right: 0;
  top: 0;
}

.dowloadApp {
  width: 100%;
  border-bottom: 1px solid @anttextcolor;

  .icon {
    color: @anttextcolor;
    width: 12px;
    height: 12px;
    padding: 10px;

  }

  img {
    height: 35px;
  }

  .btn {
    padding: 3px 5px;
    color: @textcolor1;
    background-color: @third-color;
    border-radius: 4px;
    font-size: 10px;
    margin-right: 10px;
    line-height: 1.5;
  }
}

.topLeftMenu {
  width: 20px;
  height: 20px;
  mask: url(../assets/images/leftNav/leftMenu.svg) center center no-repeat;
  transition: all .3s;
  mask-size: contain !important;
  background-color: @anttextcolor;
  margin-right: 2px;
}

.loading {
  animation: loading 1s linear infinite;
}

@keyframes loading {
  0% {
    transform: rotateZ(0deg);
  }

  100% {
    transform: rotateZ(360deg);
  }
}

.kefu_box {
  position: relative;
  margin-left: 4px;
  width: 26px;
  height: 26px;
  background: @primary-color;
  border: 1px solid @bodercolor;
  border-radius: 0.22rem;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 20px;
    height: 20px;
  }
}
</style>